import React from 'react';
import { Link } from "react-router-dom";
import { FormattedMessage } from 'react-intl';
import { PRINTERS_PATH } from '../utils/constants';
import SearchTable from './SearchTable'
import { compareStrings, TrimNan } from '../utils/utils';
import dayjs from 'dayjs';
import SuppliesHistoryChart from './SuppliesHistoryChart';

const changes_layout = {
    bordered : false,
    showSizeChanger : true, 
    pagination : {pageSize: 100, showSizeChanger: false},
    size: "small",
    rowKey : record => record.id,
};

const SuppliesChangesTable = (props) => {

    const columns = [   
        {
            title: <FormattedMessage id="SuppliesChangesTable.description"/>,
            dataIndex: 'description',           
            search: true,
            sorter: {
                    compare: (a, b) => compareStrings(a.description, b.description),
            },
        },    
        {
            title: <FormattedMessage id="SuppliesChangesTable.change_date"/>,
            dataIndex: 'changeDate',           
            search: true,
            align: 'right',
            compare: (a, b) => 
            {
                const time_a = Date.parse(a.changeDate);
                const time_b = Date.parse(b.changeDate);
                return time_a - time_b;
            },
            render: (_, record) => dayjs(record.changeDate).format('LL'),
        },    
        {
            title: <FormattedMessage id="SuppliesChangesTable.pages_count"/>,
            dataIndex: 'changePagesCount',           
            search: true,
            align: 'right',
            sorter: {
                    compare: (a, b) => TrimNan(a.changePagesCount) - TrimNan(b.changePagesCount),
            },
        },    
        {
            title: <FormattedMessage id="SuppliesChangesTable.current_level"/>,
            dataIndex: 'currentLevel',           
            search: true,
            align: 'right',
            sorter: {
                    compare: (a, b) => TrimNan(a.currentLevel) - TrimNan(b.currentLevel),
            },
        },    
        {
            title: <FormattedMessage id="SuppliesChangesTable.previous_level"/>,
            dataIndex: 'previousLevel',           
            search: true,
            align: 'right',
            sorter: {
                    compare: (a, b) => TrimNan(a.previousLevel) - TrimNan(b.previousLevel),
            },
        }, 
    ];   
        
    return (
        <div className = "report-table">
            <SearchTable
                layout = {changes_layout}
                type = {undefined}
                columns={columns} 
                dataSource={props.data} 
            />
        </div>
    );
}

const layout = {
    bordered : false,
    showSizeChanger : true, 
    pagination : {pageSize: 100, showSizeChanger: false},
    size: "small",
    rowKey : record => record.id,
    expandedRowRender: (record) => <div style={{ margin: 0 }}>{
           <SuppliesHistoryChart chartData = {record}/>}
           {   record.supplies instanceof Array &&
               record.supplies.length > 0 &&
               <div className = "nested-report-table"><SuppliesChangesTable data = {record.supplies}/></div>
           }
       </div>,
};

const SuppliesHistoryTableEx = (props) => {

    const columns = [   
        {
            title: <FormattedMessage id="DeviceMetersTable.name"/>,
            dataIndex: 'name',           
            search: true,
            sorter: {
                    compare: (a, b) => compareStrings(a.name, b.name),
            },
            render: (_, record) => {        
                const url = PRINTERS_PATH + "/" + record.id;
                return(
                <div>
                    <div style={{ background: "Bisque" }}><h3><Link to={url}>{record.name}</Link></h3></div>
                </div>
                );        
            }
        },    
    ];   
        
    return (
        <div className = "report-table">
            <SearchTable
                layout = {layout}
                type = {undefined}
                columns={columns} 
                dataSource={props.data} 
            />
        </div>
    );
}

export default SuppliesHistoryTableEx;
